import React from "react";
import { InnerFormTemplate } from "components/MainSectionTemplate/InnerFormTemplate";
import OptionalTextInput from "components/ValidatedFields/OptionalTextInput";
import { EmailInput } from "components";

interface Props {
  driver: server.dto.Driver
  onChange: (value: server.dto.Driver) => void;
  submit: () => void;
}

export const DriverInnerForm = (props: Props) => {
  return <InnerFormTemplate
    submit={props.submit}
    section={{
      key: "driver",
      title: "",
      type: "regular",
      fields: [{
        key: "name",
        label: RESX.GroundTransport.DriverName,
        renderEditNew: () => <OptionalTextInput
          focusOnMount
          maxLength={serverReference.constants.groundTransport.maxDriverNameLength}
          value={props.driver.name || ""}
          onChange={(value) => props.onChange({
            ...props.driver,
            name: value
          })}
        />
      }, {
        key: "mobile",
        label: RESX.GroundTransport.DriverMobile,
        renderEditNew: () => <OptionalTextInput
          maxLength={serverReference.constants.groundTransport.maxDriverMobileLength}
          value={props.driver.mobile || ""}
          onChange={(value) => props.onChange({
            ...props.driver,
            mobile: value
          })}
        />
      }, {
        key: "email",
        label: RESX.GroundTransport.DriverEmail,
        renderEditNew: () => <EmailInput
          maxLength={serverReference.constants.groundTransport.maxDriverEmailLength}
          value={props.driver.email || ""}
          onChange={(value) => props.onChange({
            ...props.driver,
            email: value
          })}
          emailCanBeBlank
          validatorKey="driverEmail"
        />
      }, {
        key: "vehicleModel",
        label: RESX.GroundTransport.Vehicle,
        renderEditNew: () => <OptionalTextInput
          maxLength={serverReference.constants.groundTransport.maxDriverVehicleLength}
          value={props.driver.vehicle || ""}
          onChange={(value) => props.onChange({
            ...props.driver,
            vehicle: value
          })}
        />
      }]
    }}
  />
}

